import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const InAppLine24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 5H5C4.72386 5 4.5 5.22386 4.5 5.5V6.75H19.5V5.5C19.5 5.22386 19.2761 5 19 5ZM4.5 18.5V8.25H19.5V18.5C19.5 18.7761 19.2761 19 19 19H5C4.72386 19 4.5 18.7761 4.5 18.5ZM5 3.5C3.89543 3.5 3 4.39543 3 5.5V18.5C3 19.6046 3.89543 20.5 5 20.5H19C20.1046 20.5 21 19.6046 21 18.5V5.5C21 4.39543 20.1046 3.5 19 3.5H5ZM9.01373 16.781C9.38407 17.1008 9.94928 17.0663 10.2762 16.704C10.603 16.3417 10.5678 15.7888 10.1974 15.469C9.63891 14.9867 9.28881 14.2839 9.28881 13.5C9.28881 12.7161 9.63891 12.0133 10.1974 11.531C10.5678 11.2112 10.603 10.6583 10.2762 10.296C9.94928 9.93368 9.38407 9.89921 9.01373 10.219C8.0868 11.0194 7.5 12.1932 7.5 13.5C7.5 14.8068 8.0868 15.9806 9.01373 16.781ZM13 13.5C13 14.0523 12.5523 14.5 12 14.5C11.4477 14.5 11 14.0523 11 13.5C11 12.9477 11.4477 12.5 12 12.5C12.5523 12.5 13 12.9477 13 13.5ZM13.7238 16.704C14.0507 17.0663 14.6159 17.1008 14.9863 16.781C15.9132 15.9806 16.5 14.8068 16.5 13.5C16.5 12.1932 15.9132 11.0194 14.9863 10.219C14.6159 9.89921 14.0507 9.93368 13.7238 10.296C13.397 10.6583 13.4322 11.2112 13.8026 11.531C14.3611 12.0133 14.7112 12.7161 14.7112 13.5C14.7112 14.2839 14.3611 14.9867 13.8026 15.469C13.4322 15.7888 13.397 16.3417 13.7238 16.704Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
